/** @jsx jsx */
import { CheckIcon, Heading, IconedList, IconedListItem, Stack } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";

export interface BenefitsSectionProps {
  benefits: string[];
}

export const BenefitsSection: FC<BenefitsSectionProps> = ({ benefits }) => {
  const { t } = useTranslation("public");

  return (
    <ResponsiveCard>
      <Stack gap="md">
        <Heading size="h-sm">{t("CLIENT_PAGE.DETAILS.COMPANY_BENEFITS.HEADER")}</Heading>

        <IconedList columnCount={[1, null, null, 2]}>
          {benefits.map((benefit, benefitIndex) => (
            <IconedListItem key={benefitIndex} icon={<CheckIcon />} text={benefit} />
          ))}
        </IconedList>
      </Stack>
    </ResponsiveCard>
  );
};
